module.exports = __webpack_public_path__ + "img/1567956138.7d9b91fb.jpg";